// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { css, cx } from '@emotion/css';

import { useMapSurfaceColors } from './useMapSurfaceColors';

// TYPES ---------------------------------------------------------------- //

interface GoogleMapsElementProps extends React.HTMLAttributes<HTMLDivElement> {
  rounded?: boolean;
  disablePadding?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const GoogleMapsElement = React.forwardRef<HTMLDivElement, GoogleMapsElementProps>(
  ({ children, style, className, rounded, disablePadding, ...rest }, ref) => {
    const { panelBackground, divider } = useMapSurfaceColors();
    const cls = useStyles({ rounded, disablePadding, panelBackground, border: divider });

    return (
      <div ref={ref} className={cx(cls.element, className)} style={style} {...rest}>
        {children}
      </div>
    );
  }
);

GoogleMapsElement.displayName = 'GoogleMapsElement';

const useStyles = (
  props: { rounded?: boolean; disablePadding?: boolean; panelBackground: string; border?: string }
) => {
  return {
    element: css`
      z-index: 1;
      position: absolute;
      background: ${props.panelBackground};
      padding: ${props?.disablePadding ? '0' : '8px'};
      border: 1px solid ${props.border};
      border-radius: ${props?.rounded ? '48px' : '8px'};
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
      backdrop-filter: blur(6px);
    `,
  };
};

// EXPORT ---------------------------------------------------------------- //

export default GoogleMapsElement;
